module.exports = __webpack_public_path__ + "files/4d8cfba5f653537e664e7323c378c1ea.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/themes/mattermost_dark.png
 ** module id = 825
 ** module chunks = 0
 **/